import React from "react";
import Footer from "../Templete/Footer";
import Header from "../Templete/Header";
import SignupBanner from "../Home/SignupBanner";

const RechargeBillPayment = () => {
  // Set page title and meta description
  React.useEffect(() => {
    document.title =
      "Recharge & Bill Payment API | FORMAX PAY - Mobile, DTH, Electricity, Gas, Water Bill Payments";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      const newMeta = document.createElement("meta");
      newMeta.name = "description";
      newMeta.content =
        "API for recharge and bill payment services. Mobile recharge, DTH recharge, electricity, gas, water bill payments through robust APIs. Instant processing and complete MIS reports.";
      document.head.appendChild(newMeta);
    }
  }, []);

  return (
    <>
      <Header />

      {/* SEO: Structured Data Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Recharge & Bill Payment API",
          description:
            "API integration for mobile recharge, DTH recharge, electricity, gas, water bill payments. Partner program with instant processing and complete reports.",
          provider: {
            "@type": "Organization",
            name: "Formax IT Solutions Private Limited",
            legalName: "Formax IT Solutions Private Limited",
            url: "https://formaxpay.com",
          },
          serviceType: ["Recharge API", "Bill Payment API", "Utility Services"],
          areaServed: "India",
          offers: {
            "@type": "Offer",
            category: "Financial Services",
          },
        })}
      </script>

      {/* Hero Section */}
      <section className="bg-half-170 bg-light d-table w-100">
        <div className="container">
          <div className="row mt-5 justify-content-center">
            <div className="col-lg-10 text-center">
              <div className="pages-heading">
                <h1 className="title mb-4" style={{ fontSize: "2.5rem" }}>
                  Recharge & Bill Payment API
                </h1>
                <p className="text-muted para-desc mx-auto mb-0 fs-5">
                  Comprehensive API solutions for mobile recharge, DTH recharge,
                  and utility bill payments. Enable your platform to offer
                  seamless recharge and bill payment services to your users.
                </p>
                <div className="mt-3">
                  <div className="badge bg-primary bg-opacity-10 text-white px-3 py-2 rounded-pill">
                    <i className="uil uil-percentage me-1"></i>
                    Earn up to 5% commission on every recharge transaction
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Shape Divider */}
      <div className="position-relative">
        <div className="shape overflow-hidden text-white">
          <svg
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>

      {/* Recharge & Bill Payment Services Section */}
      <section className="section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
              <div className="position-relative">
                <img
                  src="/images/recharge-banner-2.png"
                  className="rounded img-fluid mx-auto d-block"
                  alt="Recharge & Bill Payment Services"
                />
              </div>
            </div>

            <div className="col-lg-7 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
              <div className="section-title ms-lg-4">
                <h4 className="title mb-4">
                  Complete Recharge & Bill Payment Solutions
                </h4>
                <p className="text-muted">
                  FORMAX PAY provides comprehensive recharge and bill payment
                  services through robust API integration. Enable your platform
                  to offer
                  <span className="text-primary fw-bold">
                    {" "}
                    instant recharge and bill payment
                  </span>{" "}
                  services directly to your users. Our APIs support all major
                  operators and utility providers.
                </p>
                <div className="row mt-4">
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Mobile Recharge
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        DTH Recharge
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Fastag Recharge
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Google Play Recharge
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Electricity Bill Payment
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Gas Bill Payment
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Insurance Bill Payment
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Water Bill Payment
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Broadband Bill Payment
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Landline Bill Payment
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Municipal Tax Payments
                      </li>
                      <li className="mb-2">
                        <i className="uil uil-check-circle text-success me-2"></i>
                        Loan EMI Payments
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Commission & Partnership Banner */}
      <section className="section bg-primary bg-opacity-10">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="section-title">
                <h4 className="title mb-3 text-white">
                  Licensed Bharat Connect AI Partner
                </h4>
                <p className="text-white mb-0">
                  <span className=" fw-bold">FORMAX IT SOLUTIONS</span> is a
                  licensed partner of
                  <span className="t fw-bold"> Bharat Connect AI</span>,
                  providing access to all billers available in the Bharat
                  Connect ecosystem. We ensure 100% biller coverage across all
                  categories.
                </p>
              </div>
            </div>
            <div className="col-lg-4 text-center">
              <div className="bg-white rounded p-4 shadow-sm">
                <h5 className="text-primary mb-2">Earn Commission</h5>
                <div className="display-4 text-primary fw-bold">Up to 5%</div>
                <p className="text-muted small mb-0">
                  On every recharge transaction
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="section bg-light" id="features">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title mb-4 pb-2">
                <h4 className="title mb-4">
                  Why Choose Our Recharge & Bill Payment API
                </h4>
                <p className="text-muted para-desc mx-auto mb-0">
                  Comprehensive API solutions designed for seamless integration
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-bolt-alt fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Instant Processing</h5>
                  <p className="text-muted mb-0">
                    Real-time recharge and bill payment processing with
                    immediate confirmation.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-shield-check fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">99.9% Success Rate</h5>
                  <p className="text-muted mb-0">
                    High success rate with automated fallback mechanisms for
                    failed transactions.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-percentage fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Competitive Commission</h5>
                  <p className="text-muted mb-0">
                    Earn up to 5% commission on every recharge transaction with
                    daily settlements.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-code-branch fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Easy API Integration</h5>
                  <p className="text-muted mb-0">
                    Simple REST APIs with comprehensive documentation and SDK
                    support.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-file-check fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Real-time Notifications</h5>
                  <p className="text-muted mb-0">
                    Instant transaction notifications via webhooks for seamless
                    user experience.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-headphones-alt fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">24/7 Billing & Support</h5>
                  <p className="text-muted mb-0">
                    Round-the-clock customer support and automated billing
                    system.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-analytics fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Complete MIS Reports</h5>
                  <p className="text-muted mb-0">
                    Detailed dashboard with comprehensive reports, analytics,
                    and settlement statements.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-transaction fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Multi-operator Support</h5>
                  <p className="text-muted mb-0">
                    Support for all major telecom operators, DTH providers, and
                    utility companies.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4 pt-2">
              <div className="card features feature-primary border-0 p-4 rounded shadow">
                <div className="icon text-center rounded-lg text-primary mb-3">
                  <i className="uil uil-server-network fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Bharat Connect Ecosystem</h5>
                  <p className="text-muted mb-0">
                    Access to all billers available in the Bharat Connect AI
                    ecosystem.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bharat Connect Partnership Section */}
      <section className="section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="section-title">
                <h4 className="title mb-4">Powered by Bharat Connect AI</h4>
                <p className="text-muted">
                  As a licensed partner of Bharat Connect AI, we provide access
                  to the entire biller ecosystem. Enjoy comprehensive coverage
                  across all categories with guaranteed service availability.
                </p>
                <ul className="list-unstyled text-muted">
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Access to 1000+ billers across India
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Licensed and authorized bill payment services
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Real-time biller updates and additions
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Seamless integration with Bharat Connect AI infrastructure
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    24/7 auto billing system with zero downtime
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Complete compliance with regulatory standards
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/bharat-connect-partnership.png"
                className="img-fluid rounded shadow"
                alt="Bharat Connect AI Partner"
              />
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="section bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title mb-5">
                <h4 className="title mb-4">Simple Integration Process</h4>
                <p className="text-muted para-desc mx-auto">
                  Get started with recharge & bill payment services in 4 easy
                  steps
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-6 pt-2">
              <div className="card border-3 text-center features feature-primary p-3">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-user-plus fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">1. Register</h5>
                  <p className="text-muted mb-0">
                    Sign up as an API partner & complete documentation process
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 pt-2">
              <div className="card border-3 text-center features feature-primary p-3">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-key-skeleton fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">2. Get API Keys</h5>
                  <p className="text-muted mb-0">
                    Generate API credentials from dashboard, whitelist IP and
                    update webhook URLs
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 pt-2">
              <div className="card border-3 text-center features feature-primary p-3">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-arrow fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">3. Integrate</h5>
                  <p className="text-muted mb-0">
                    Implement recharge & bill payment APIs into your platform
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 pt-2">
              <div className="card border-3 text-center features feature-primary p-3">
                <div className="icon text-center rounded-circle mx-auto">
                  <i className="uil uil-rocket fs-2"></i>
                </div>
                <div className="content mt-3">
                  <h5 className="mb-2">4. Go Live</h5>
                  <p className="text-muted mb-0">
                    Start offering recharge & bill payment services to your
                    customers
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="section-title">
                <h4 className="title mb-4">Benefits for Your Business</h4>
                <p className="text-muted">
                  Integrate recharge and bill payment services to enhance your
                  platform's offerings and increase user engagement and revenue.
                </p>
                <ul className="list-unstyled text-muted">
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Increase user retention and engagement
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Generate additional revenue streams (up to 5% commission)
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Enhance platform utility and value proposition
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Real-time commission settlements
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Complete transaction history and reporting
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    24/7 auto billing system with customer support
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    No minimum balance requirements
                  </li>
                  <li className="mb-2">
                    <i className="uil uil-check-circle text-success me-2"></i>
                    Access to Bharat Connect AI's complete biller ecosystem
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/business-benefits.png"
                className="img-fluid rounded shadow"
                alt="Recharge Benefits"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="section bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title mb-4">
                <h4 className="title mb-4">Ideal For</h4>
                <p className="text-muted para-desc mx-auto">
                  Our recharge & bill payment API is perfect for various
                  business use cases
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 mt-4">
              <div className="card border-0 text-center features feature-primary p-4">
                <div className="icon text-center rounded-circle mx-auto mb-3">
                  <i className="uil uil-mobile-android fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Fintech & Payment Apps</h5>
                  <p className="text-muted mb-0">
                    Add recharge and bill payment as core features in your
                    payment app.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4">
              <div className="card border-0 text-center features feature-primary p-4">
                <div className="icon text-center rounded-circle mx-auto mb-3">
                  <i className="uil uil-shopping-cart fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">E-commerce Platforms</h5>
                  <p className="text-muted mb-0">
                    Offer utility services as value-added services to your
                    customers.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 mt-4">
              <div className="card border-0 text-center features feature-primary p-4">
                <div className="icon text-center rounded-circle mx-auto mb-3">
                  <i className="uil uil-building fs-2"></i>
                </div>
                <div className="content">
                  <h5 className="mb-2">Corporate Portals</h5>
                  <p className="text-muted mb-0">
                    Enable employees to pay bills directly through corporate
                    portals.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SignupBanner />

      <Footer />
    </>
  );
};

export default RechargeBillPayment;
